<script setup lang="ts">
import { ref } from 'vue'

const sidebarCollapsed = ref<boolean>(false)
</script>

<template>
  <el-container class="flex h-screen overflow-auto">
    <side-navigation v-model="sidebarCollapsed" />
    <main class="overflow-auto flex-basis-0 flex-grow-1" :class="sidebarCollapsed ? 'pl-16' : 'pl-64'">
      <router-view />
    </main>
  </el-container>
</template>
